/**
 * This is the Tabs widget
 *
 * optional @prop widgetId {String} widget ID
 * optional @prop position {String} Position of the widget
 *                valid positions are left or right
 * optional @prop onSelectTab {Func} what to do when a user selects a tab
 * optional @prop selectedTab {String} The selected tab's ID
 * optional @prop tabs {Array} List of tabs
 *          expected structure is [{ id: ID, value: value }, ... ]
 * optional @prop children {Object} content of the selected tab
 *
 * return widgetID: {String} widget ID
 *        selectedElemID: {String} selected tab ID
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import displayName from 'component-lib/displayName';

import TextLabel from './Labels/TextLabel';

import styles from './Tabs.scss';

export default class Tabs extends Component {
    static displayName = displayName('Widgets/Tabs');

    static propTypes = {
        widgetId: PropTypes.string,
        position: PropTypes.string,
        tabs: PropTypes.array,
        selectedTab: PropTypes.string,
        onSelectTab: PropTypes.func,
        children: PropTypes.any,
        className: PropTypes.string,
    };

    static defaultProps = {
        widgetId: '',
        position: 'left',
        tabs: [],
        selectedTab: '',
        onSelectTab: () => {},
        children: null,
        className: '',
    };

    onTabSelect = tabId => () => this.props.onSelectTab(this.props.widgetId, tabId);

    renderTabs() {
        return (
            this.props.tabs.map((tab) => {
                let tabStyle = 'tab';
                if (tab.id === this.props.selectedTab) tabStyle += '-selected';

                return (
                    <TextLabel
                        key={tab.id}
                        data-action={tab.id}
                        className={styles[tabStyle]}
                        onClick={this.onTabSelect(tab.id)}
                    >
                        {tab.value}
                    </TextLabel>
                );
            })
        );
    }

    render() {
        const widgetProps = omit(this.props, [
            'widgetId',
            'position',
            'tabs',
            'selectedTab',
            'onSelectTab',
            'children',
            'styleName',
            'styles',
            'className',
        ]);

        let className = styles[`tabs-${this.props.position}`];
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }

        return (
            <data>
                <div
                    {...widgetProps}
                    data-field={`tabs-${this.props.widgetId}`}
                    className={className}
                >
                    {this.renderTabs()}
                </div>

                {this.props.children &&
                <div className={styles['tab-content']}>
                    {this.props.children}
                </div>
                }
            </data>
        );
    }
}
